import { IOrderRemainingHoursReport } from '../types/orderRemainingHoursReport';

export const groupOrderRemainingTotal = (data: IOrderRemainingHoursReport[]) => {
    let groupData: any = {};
    let total9 = 0;
    let total10 = 0;
    let total11 = 0;
    data.forEach((it) => {
        total9 += it.futureIncome ? it.futureIncome : 0;
        total10 += it.amountOfRemainingHours ? it.amountOfRemainingHours : 0;
        total11 += it.monthLeftOfRemainingHours ? it.monthLeftOfRemainingHours : 0;
    });

    groupData = {
        id: ``,
        totalRow: true,
        name: '',
        orderType: ``,
        caseNumber: ``,
        'student.lastName': '',
        student: {
            id: '',
            lastName: '',
            firstName: '',
        },
        serviceType: {
            id: '',
            title: '',
            cpt: '',
            isEvaluation: false,
        },
        recentOrders: '',
        externalRate: '',
        futureIncome: total9,
        amountOfRemainingHours: total10,
        monthLeftOfRemainingHours: total11,
    };

    return groupData;
};
